import React from "react"

import type { ChatContextType } from "./ChatContext"
import { ChatContext } from "./ChatContext"

/**
 * Minimal stub of ChatContext for unauthenticated screens.
 * Provides the real ChatContext so `useChat()` resolves.
 * AvatarOverlay only calls `startNewConversation` (inside the Switch-to-PSK flow),
 * which is hidden via `hideConversationControls` prop and should never fire.
 * All other values are safe inert defaults.
 */

const NO_OP = () => {}
const NO_OP_ASYNC = async () => {}

const STUB_VALUE: ChatContextType = {
  sendMessage: NO_OP,
  startConversation: NO_OP_ASYNC,
  startNewConversation: NO_OP,
  currentLLMId: undefined,
  setCurrentLLMId: NO_OP,
  showDebugMessages: false,
  setShowDebugMessages: NO_OP,
  audioStreamingReady: false,
  startMicStream: NO_OP,
  sendAudioChunk: NO_OP,
  stopMicStream: NO_OP,
  cancelMicStream: NO_OP,
  cancelWaitingForWelcomeMessage: NO_OP,
  sendSimulateEvent: NO_OP,
  sendUserReport: NO_OP,
  isSwitchingSidekick: false,
  setIsSwitchingSidekick: NO_OP,
  startConversationStatus: { isPending: false },
  startConversationTimedOut: false,
  clearStartConversationTimedOut: NO_OP,
  wordsDone: true,
  waitingForWelcomeMessage: false,
  isSidekickBusy: false,
}

export function UnauthChatProvider({ children }: React.PropsWithChildren) {
  return <ChatContext.Provider value={STUB_VALUE}>{children}</ChatContext.Provider>
}
